import React, { useState, useEffect } from 'react';

const ProgressIndicator = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = Math.min((scrollTop / docHeight) * 100, 100);
      
      setScrollProgress(scrollPercent);
      
      // Show progress indicator after hero section
      setIsVisible(scrollTop > window.innerHeight * 0.3);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial call
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="progress-indicator fixed top-0 left-0 w-full h-1 bg-surface/50 z-110">
      <div 
        className="h-full bg-gradient-to-r from-primary via-secondary to-accent transition-all duration-100 ease-out"
        style={{ 
          width: `${scrollProgress}%`,
          boxShadow: scrollProgress > 0 ? '0 0 10px rgba(124, 58, 237, 0.5)' : 'none'
        }}
      />
      
      {/* Progress percentage indicator (optional, shows on hover) */}
      <div 
        className="absolute top-full left-0 bg-surface text-text-primary px-2 py-1 rounded-b text-xs font-medium opacity-0 hover:opacity-100 transition-opacity duration-250"
        style={{ left: `${Math.max(0, Math.min(scrollProgress - 5, 95))}%` }}
      >
        {Math.round(scrollProgress)}%
      </div>
    </div>
  );
};

export default ProgressIndicator;